// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-style {
  padding: 1.25rem;
  box-shadow: rgba(4, 9, 20, 0.03) 0px 0.46875rem 2.1875rem, rgba(4, 9, 20, 0.03) 0px 0.9375rem 1.40625rem, rgba(4, 9, 20, 0.05) 0px 0.25rem 0.53125rem, rgba(4, 9, 20, 0.03) 0px 0.125rem 0.1875rem;
  border-width: 0px;
}

.profile-update-button {
  background-color: #008cce !important;
  float: right;
  border: 1px solid #008cce !important;
  color: white;
  border-radius: 3px;
  font-size: 16px;
  font-weight: 500;
  outline: none;
  padding: 8px 10px;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  font-family: "Source Sans Pro", sans-serif;
  box-shadow: 0px 4px 8px 0px rgba(55, 63, 80, 0.2509803922);
}

.profile-update-button:hover {
  background-color: white;
  color: #008cce;
}

.disabled-profile-update-button {
  background-color: #D3D7E0;
  float: right;
  border: 1px solid #D3D7E0;
  color: rgba(55, 63, 80, 0.3);
  border-radius: 3px;
  font-size: 16px;
  font-weight: 500;
  outline: none;
  padding: 8px 10px;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  font-family: "Source Sans Pro", sans-serif;
}

.password-error {
  color: #B00020;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 12px;
  padding-bottom: 15px;
}

.reminder-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 12px;
  color: #6c757d;
  padding-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/manage_profile/components/manageProfile.scss"],"names":[],"mappings":"AAKA;EACE,gBAAA;EACA,kMAAA;EACA,iBAAA;AAJF;;AAMA;EACE,oCAAA;EACA,YAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,0CAAA;EACA,0DAAA;AAHF;;AAKA;EACE,uBAAA;EACA,cA5Bc;AA0BhB;;AAIA;EACE,yBA9BkB;EA+BlB,YAAA;EACA,yBAAA;EACA,4BAhCuB;EAiCvB,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,0CAAA;AADF;;AAGA;EACE,cAAA;EACA,0CAAA;EACA,eAAA;EACA,oBAAA;AAAF;;AAGA;EACE,0CAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AAAF","sourcesContent":["$dj-blue-color: #008cce;\n$dj-disabled-color: #D3D7E0;\n$dj-disabled-font-color: rgba(55, 63, 80, 0.3);\n\n\n.card-style{\n  padding: 1.25rem;\n  box-shadow: rgb(4 9 20 / 3%) 0px 0.46875rem 2.1875rem, rgb(4 9 20 / 3%) 0px 0.9375rem 1.40625rem, rgb(4 9 20 / 5%) 0px 0.25rem 0.53125rem, rgb(4 9 20 / 3%) 0px 0.125rem 0.1875rem;\n  border-width: 0px;\n}\n.profile-update-button{\n  background-color: $dj-blue-color !important;\n  float: right;\n  border: 1px solid $dj-blue-color !important;\n  color: white;\n  border-radius: 3px;\n  font-size: 16px;\n  font-weight: 500;\n  outline: none;\n  padding: 8px 10px;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  font-family: 'Source Sans Pro', sans-serif;;\n  box-shadow: 0px 4px 8px 0px #373F5040;\n}\n.profile-update-button:hover{\n  background-color: white;\n  color: $dj-blue-color;\n}\n.disabled-profile-update-button{\n  background-color: $dj-disabled-color;\n  float: right;\n  border: 1px solid $dj-disabled-color;\n  color: $dj-disabled-font-color;\n  border-radius: 3px;\n  font-size: 16px;\n  font-weight: 500;\n  outline: none;\n  padding: 8px 10px;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  font-family: 'Source Sans Pro', sans-serif;;\n}\n.password-error{\n  color: #B00020;\n  font-family: 'Source Sans Pro', sans-serif;;\n  font-size: 12px;\n  padding-bottom: 15px;\n\n}\n.reminder-text{\n  font-family: 'Source Sans Pro', sans-serif;;\n  font-size: 12px;\n  color: #6c757d;\n  padding-bottom: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
